import { forwardRef, system } from '@hover/blueprint';
import React from 'react';
import { Trans } from 'react-i18next';

import type { TextOverlayProps } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { TextOverlay } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks';

import { LoadingTextEllipsis } from '../../LoadingText';

export interface CustomizingOverlayProps
  extends Exclude<TextOverlayProps, 'children'> {
  /**
   * The verb that appears before the `customization` text in the loading copy
   */
  verb: string;
  /**
   * A label for the customization that is being applied, e.g: "Tranquil Gray"
   */
  customization: string | undefined;
}

export const CustomizingOverlay = forwardRef<CustomizingOverlayProps, 'div'>(
  ({ verb, customization, ...props }, ref) => {
    const t = useHomeownerTranslate();

    return (
      <TextOverlay ref={ref} {...props}>
        {customization ? (
          <Trans
            components={{
              Customization: <system.span />,
              Ellipsis: <LoadingTextEllipsis />,
              LineBreak: (
                <>
                  <system.br display={{ base: 'none', tablet: 'inline' }} />
                  <system.span display={{ base: 'inline', tablet: 'none' }}>
                    {' '}
                  </system.span>
                </>
              ),
            }}
            i18nKey="customize.overlay.customizing"
            t={t}
            values={{ customization, verb }}
          />
        ) : (
          <>
            &nbsp;
            <system.br display={{ base: 'none', tablet: 'inline' }} />
            &nbsp;
          </>
        )}
      </TextOverlay>
    );
  },
);
